/*
 * Behaviour for the Nextcom sections (sections/nx-*.liquid).
 * Each part binds to its own data- attribute, so a section missing from the
 * page costs nothing. Re-binds when the theme editor reloads a section.
 */
(function () {
  'use strict';

  /* Feature picker: tabs with arrow/Home/End keys, "Add to my quote" ticks,
     and a quote button that carries the picks into the contact form. */
  function bindFeatures(root) {
    if (root.dataset.nxBound) return;
    root.dataset.nxBound = '1';
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var boxes = [].slice.call(root.querySelectorAll('[data-nxf-pick]'));
    var status = root.querySelector('[data-nxf-status]');
    var button = root.querySelector('[data-nxf-quote]');

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      if (tab.scrollIntoView && focus) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j !== null) { e.preventDefault(); select(tabs[j], true); }
      });
    });

    function picked() {
      return boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
    }

    function update() {
      boxes.forEach(function (b) {
        var tab = document.getElementById(b.dataset.nxfTab);
        if (tab) tab.classList.toggle('is-picked', b.checked);
      });
      var names = picked();
      if (!status) return;
      if (names.length) {
        status.textContent = status.dataset.prefix + ' ' + names.join(', ') + '.';
      } else {
        status.innerHTML = '';
        status.appendChild(document.createTextNode(status.dataset.empty + ' '));
        var hint = document.createElement('span');
        hint.textContent = status.dataset.hint;
        status.appendChild(hint);
      }
    }
    boxes.forEach(function (b) { b.addEventListener('change', update); });
    update();

    if (button) {
      button.addEventListener('click', function (e) {
        var form = document.querySelector('[data-nx-contact]');
        if (!form) return;
        e.preventDefault();
        var names = picked();
        var hidden = form.querySelector('[data-nx-features]');
        if (hidden) hidden.value = names.join(', ');
        var message = form.querySelector('[data-nx-message]');
        if (message && names.length) {
          var line = (button.dataset.prefill || "I'd like a quote for:") + ' ' + names.join(', ') + '.';
          // Replace the line a previous press wrote, keep whatever the person typed.
          var rest = message.value;
          var prev = message.dataset.nxPrefilled;
          if (prev && rest.indexOf(prev) === 0) rest = rest.slice(prev.length).replace(/^\n+/, '');
          message.value = line + (rest ? '\n\n' + rest : '');
          message.dataset.nxPrefilled = line;
        }
        form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        var first = form.querySelector('input:not([type="hidden"])');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      });
    }
  }

  /* Click-to-load YouTube: the poster is a link to the video until pressed. */
  function bindVideo(root) {
    if (root.dataset.nxBound) return;
    root.dataset.nxBound = '1';
    var poster = root.querySelector('.nx-video__poster');
    if (!poster) return;
    poster.addEventListener('click', function (e) {
      e.preventDefault();
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(root.dataset.nxVideo) + '?autoplay=1&rel=0';
      frame.title = root.dataset.title || 'Video';
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      root.replaceChildren(frame);
      frame.focus();
    });
  }

  /* Long reviews show seven lines and a Read more button, only when clamped. */
  function bindQuote(body) {
    if (body.dataset.nxBound) return;
    body.dataset.nxBound = '1';
    var more = body.parentNode.querySelector('.nx-quote__more');
    if (!more) return;
    body.classList.add('is-clamped');
    if (body.scrollHeight - body.clientHeight < 4) {
      body.classList.remove('is-clamped');
      return;
    }
    more.hidden = false;
    more.addEventListener('click', function () {
      var open = body.classList.toggle('is-clamped') === false;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? more.dataset.less : more.dataset.more;
    });
  }

  /* A collapsed set of testimonials: the button opens it once and goes, and focus
     lands on the set's heading. Find-in-page opens it too (beforematch). */
  function openPanel(panel, focus) {
    var section = panel.closest('.nx-testimonials--collapsed');
    var button = section && section.querySelector('[data-nx-reveal]');
    panel.hidden = false;
    if (section) section.classList.add('is-open');
    if (button) {
      button.setAttribute('aria-expanded', 'true');
      button.hidden = true;
    }
    // A closed panel measures nothing, so its long quotes are clamped now.
    init(panel);
    var heading = focus && panel.querySelector('h2');
    if (heading) {
      heading.tabIndex = -1;
      heading.focus({ preventScroll: true });
    }
  }

  function bindReveal(button) {
    if (button.dataset.nxBound) return;
    button.dataset.nxBound = '1';
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.addEventListener('click', function () { openPanel(panel, true); });
    panel.addEventListener('beforematch', function () { openPanel(panel, false); });
  }

  /* A screen pressed opens full size in one dialog, made the first time it is needed. A press on
     the backdrop closes it, as Close and Escape do. Without dialog support the press does nothing. */
  var zoom;
  function zoomDialog() {
    if (zoom) return zoom;
    zoom = document.createElement('dialog');
    zoom.className = 'nxd-zoom';
    zoom.setAttribute('aria-label', 'Full size');
    zoom.innerHTML = '<form method="dialog"><button type="submit">Close</button></form><img alt="">';
    zoom.addEventListener('click', function (e) { if (e.target === zoom) zoom.close(); });
    zoom.addEventListener('close', function () { zoom.querySelector('img').removeAttribute('src'); });
    document.body.appendChild(zoom);
    return zoom;
  }
  function bindZoom(button) {
    if (button.dataset.nxBound) return;
    button.dataset.nxBound = '1';
    button.addEventListener('click', function () {
      var shot = button.querySelector('img');
      if (!shot || typeof HTMLDialogElement !== 'function') return;
      var dialog = zoomDialog();
      var big = dialog.querySelector('img');
      big.src = button.getAttribute('data-nx-zoom');
      big.alt = shot.alt;
      dialog.showModal();
    });
  }

  function init(scope) {
    var root = scope || document;
    [].forEach.call(root.querySelectorAll('[data-nxf]'), bindFeatures);
    [].forEach.call(root.querySelectorAll('[data-nx-zoom]'), bindZoom);
    [].forEach.call(root.querySelectorAll('[data-nx-video]'), bindVideo);
    [].forEach.call(root.querySelectorAll('[data-nx-reveal]'), bindReveal);
    [].forEach.call(root.querySelectorAll('.nx-quote__body'), function (body) {
      if (!body.closest('[data-nx-reveal-panel][hidden]')) bindQuote(body);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // In the theme editor, selecting the collapsed section or one of its testimonials opens it.
  ['shopify:section:select', 'shopify:block:select'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var panel = e.target.querySelector && (e.target.closest('[data-nx-reveal-panel]') || e.target.querySelector('[data-nx-reveal-panel]'));
      if (panel && panel.hidden) openPanel(panel, false);
    });
  });
})();
